import React, { useState } from 'react';
import '../styles/AllProductsGrid.css';
import QuoteModal from './QuoteModal';
import product1 from '../assets/bg4.png';
import product2 from '../assets/Day 10.png';
import product3 from '../assets/Day 10.png';

const AllProductsGrid = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  const openQuoteModal = () => {
    setIsQuoteModalOpen(true);
  };

  const closeQuoteModal = () => {
    setIsQuoteModalOpen(false);
  };

  const products = [
    {
      id: 1,
      name: 'QuickFit ANC R',
      tagline: 'Essential Rechargeable',
      image: product1,
      price: 'B2B Price on Request',
      badge: 'Best Seller',
      specifications: {
        battery: 'Rechargeable Lithium-ion',
        batteryLife: 'Up to 10 hours',
        batteryLifeWithCase: 'Up to 50 hours',
        chargingTime: '1-2 hours',
        charger: 'CHARGING BASE WITH LED DISPLAY',
        bluetooth: 'No',
        connectivity: 'Advanced ANC Technology',
        controls: 'Manual',
        noiseCancellation: 'Advanced ANC',
        dryClean: 'No',
        weight: '50g',
        warranty: '1 Year Manufacturing Warranty',
        colors: ['Beige', 'Brown', 'Black']
      },
      features: [
        'Rechargeable Hearing Aids',
        'Advanced ANC Technology',
        'Charging Base with LED Display',
        'Up to 50 hours total battery life',
        'Clear Speech Enhancement',
        'Manual Volume Control'
      ],
      highlights: ['Rechargeable', 'LED Display Base', 'Noise Cancellation']
    },
   
  ];

  const openModal = (product) => {
    setSelectedProduct(product);
    setShowModal(true);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedProduct(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <>
      <section id="all-products" className="all-products-section">
        <div className="all-products-container">
          
          {/* Section Header */}
          <div className="all-products-header">
            <span className="all-products-tagline">Our Complete Range</span>
            <h2 className="all-products-title">
              QuickFit <span className="all-products-highlight">Hearing Aid Series</span>
            </h2>
            <div className="all-products-underline"></div>
            <p className="all-products-subtitle">
              Choose the perfect hearing solution for your clinic or distribution network. 
              All products are backed by our quality guarantee and pan-India support.
            </p>
          </div>

          {/* Products Grid */}
          <div className="all-products-grid">
            {products.map((product) => (
              <div key={product.id} className="product-grid-card">
                {/* Badge */}
                <div className="product-grid-badge">{product.badge}</div>
                
                {/* Product Image */}
                <div className="product-grid-image">
                  <img src={product.image} alt={product.name} />
                </div>
                
                {/* Product Content */}
                <div className="product-grid-content">
                  <h3 className="product-grid-name">{product.name}</h3>
                  <p className="product-grid-tagline">{product.tagline}</p>
                  
                  {/* Highlights */}
                  <div className="product-grid-highlights">
                    {product.highlights.map((highlight, idx) => (
                      <span key={idx} className="product-grid-highlight">{highlight}</span>
                    ))}
                  </div>
                  
                  {/* Features List */}
                  <ul className="product-grid-features">
                    {product.features.slice(0, 4).map((feature, idx) => (
                      <li key={idx}>
                        <span className="product-grid-feature-icon">✓</span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                  
                  {/* Price & Actions */}
                  <div className="product-grid-footer">
                    <div className="product-grid-price">{product.price}</div>
                    <div className="product-grid-buttons">
                      <button 
                        className="product-grid-btn-details"
                        onClick={() => openModal(product)}
                      >
                        View Details
                        <svg className="product-grid-icon" viewBox="0 0 24 24" fill="none">
                          <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </button>
                      <button onClick={openQuoteModal} className="product-grid-btn-quote">
                        Request Quote
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Bulk Order CTA */}
          <div className="all-products-bulk">
            <div className="all-products-bulk-icon">🏭</div>
            <div className="all-products-bulk-content">
              <h3>Looking for Bulk Orders?</h3>
              <p>Special pricing for clinics, distributors, and hearing care professionals</p>
            </div>
            <button onClick={openQuoteModal} className="all-products-bulk-btn">
              Get Bulk Quote →
            </button>
          </div>

          {/* Modal for Product Details */}
          {showModal && selectedProduct && (
            <div className="product-modal-overlay" onClick={closeModal}>
              <div className="product-modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="product-modal-close" onClick={closeModal}>✕</button>
                
                <div className="product-modal-body">
                  <div className="product-modal-image">
                    <img src={selectedProduct.image} alt={selectedProduct.name} />
                  </div>
                  
                  <div className="product-modal-info">
                    <div className="product-modal-badge">{selectedProduct.badge}</div>
                    <h2 className="product-modal-title">{selectedProduct.name}</h2>
                    <p className="product-modal-tagline">{selectedProduct.tagline}</p>
                    
                    <div className="product-modal-features">
                      <h3>Key Features</h3>
                      <ul>
                        {selectedProduct.features.map((feature, idx) => (
                          <li key={idx}>
                            <span>✓</span> {feature}
                          </li>
                        ))}
                      </ul>
                    </div>
                    
                    <div className="product-modal-specs">
                      <h3>Technical Specifications</h3>
                      <div className="product-modal-specs-grid">
                        <div className="product-modal-spec-item">
                          <span className="spec-label">Battery Type</span>
                          <span className="spec-value">{selectedProduct.specifications.battery}</span>
                        </div>
                        <div className="product-modal-spec-item">
                          <span className="spec-label">Battery Life</span>
                          <span className="spec-value">{selectedProduct.specifications.batteryLife}</span>
                        </div>
                        <div className="product-modal-spec-item">
                          <span className="spec-label">Battery Life With Case</span>
                          <span className="spec-value">{selectedProduct.specifications.batteryLifeWithCase}</span>
                        </div>
                        <div className="product-modal-spec-item">
                          <span className="spec-label">Charging Time</span>
                          <span className="spec-value">{selectedProduct.specifications.chargingTime}</span>
                        </div>
                        <div className="product-modal-spec-item">
                          <span className="spec-label">Charger Type</span>
                          <span className="spec-value">{selectedProduct.specifications.charger}</span>
                        </div>
                        <div className="product-modal-spec-item">
                          <span className="spec-label">Bluetooth</span>
                          <span className="spec-value">{selectedProduct.specifications.bluetooth}</span>
                        </div>
                        <div className="product-modal-spec-item">
                          <span className="spec-label">Volume Control</span>
                          <span className="spec-value">{selectedProduct.specifications.controls}</span>
                        </div>
                        <div className="product-modal-spec-item">
                          <span className="spec-label">Dry & Clean</span>
                          <span className="spec-value">{selectedProduct.specifications.dryClean}</span>
                        </div>
                        <div className="product-modal-spec-item">
                          <span className="spec-label">Noise Cancellation</span>
                          <span className="spec-value">{selectedProduct.specifications.noiseCancellation}</span>
                        </div>
                        <div className="product-modal-spec-item">
                          <span className="spec-label">Weight</span>
                          <span className="spec-value">{selectedProduct.specifications.weight}</span>
                        </div>
                        <div className="product-modal-spec-item">
                          <span className="spec-label">Warranty</span>
                          <span className="spec-value">{selectedProduct.specifications.warranty}</span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="product-modal-colors">
                      <h3>Available Colors</h3>
                      <div className="product-modal-colors-list">
                        {selectedProduct.specifications.colors.map((color, idx) => (
                          <span key={idx} className="product-modal-color">{color}</span>
                        ))}
                      </div>
                    </div>
                    
                    <div className="product-modal-actions">
                      <button onClick={openQuoteModal} className="product-modal-btn-primary">
                        Request B2B Quote
                      </button>
                      <button className="product-modal-btn-secondary" onClick={closeModal}>
                        Continue Shopping
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>
      </section>

      {/* Quote Modal */}
      <QuoteModal isOpen={isQuoteModalOpen} onClose={closeQuoteModal} />
    </>
  );
};

export default AllProductsGrid;